import getMuiTheme from 'material-ui/styles/getMuiTheme';

//Default Palette: https://github.com/callemall/material-ui/blob/master/src/styles/baseThemes/lightBaseTheme.js
//Default Theme: https://github.com/callemall/material-ui/blob/master/src/styles/getMuiTheme.js

const theme = getMuiTheme({
  fontFamily:
    'Avenir Next W01, Avenir Next W00, Avenir Next, Avenir, Helvetica Neue, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: '#2b4d80',
    primary2Color: '#4fa7dd',
    primary3Color: '#099194',
    accent1Color: '#f41e30',
    accent2Color: '#0e8f49',
    accent3Color: '#2b4d80',
    accent4Color: '#ff7043',
    accent5Color: '#DACF44',
    accent6Color: '#590CF3',
    textColor: '#494949',
    secondaryTextColor: '#7f8492',
    alternateTextColor: '#fff',
    // canvasColor: white,
    borderColor: '#c1c7d4'
    // disabledColor: fade(darkBlack, 0.3),
    // pickerHeaderColor: cyan500,
    // clockCircleColor: fade(darkBlack, 0.07),
    // shadowColor: fullBlack
  },
  tableHeaderColumn: {
    height: 44,
    spacing: 8
  },
  tableRow: {
    height: 32,
    selectedColor: '#efefef'
  },
  tableRowColumn: {
    height: 32,
    spacing: 8
  },
  flatButton: {
    fontWeight: 400
  },
  raisedButton: {
    fontWeight: 400
  }
});

export default theme;



// WEBPACK FOOTER //
// ./src/muiTheme.js